import React from "react"
import { graphql, Link } from 'gatsby'
import { Row, Col, Container } from "react-bootstrap"
import Layout from "../../components/layout"
import ModalImportantNotice from "../../components/Modal/ModalImportantNotice"
import ArticleTeasers from "./ArticleTeasers"
import PeopleTeasers from "../People/PeopleTeasers"
import ProductTeasers from "../Product/ProductTeasers"
import ProspectsDownload from "../ProspectsIssues/ProspectsDownload"
import { safeDate } from '../../components/Utilities/Safe-date'
import { imageFile } from '../../components/Utilities/Image-file'
import UnderstandingFinanceImage from '../../components/Utilities/Understanding-finance-image'
import Subscribe from '../../components/DataCapture/Subscribe'
import nl2br from "react-nl2br"
import ChevronLeft from "../../assets/ChevronLeft.svg"
import IconEquity from "../../assets/icon-equity.svg"
import IconHighLow from "../../assets/icon-highlow.svg"
import IconHist from "../../assets/icon-histpros.svg"
import IconPrice from "../../assets/icon-price.svg"
import IconYield from "../../assets/icon-yield.svg"
import IconDownload from "../../assets/Union.svg"
import FramerMotionAnimation from "../../components/Utilities/Animations/FramerMotion"
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'
import { richTextFilter } from '../../components/Utilities/Rich-text-filter'

// SEO imports
import SEO from '../../components/SEO/SEO'
import { renderHead } from '../../components/SEO/SEO'
import { Helmet } from "react-helmet"
// SEO imports - end


const ArticlePage = ({ data }) => {

  // SEO data start
  const { title } = data.content
  const { id } = data.content.drupal_internal__nid
  // SEO data end

  // related article layout
  const colPattern = {
    xs:[12,12,12],
    md:[12,6,6],
    lg:[4,{ span: 3, offset: 1 },{ span: 3, offset: 1 }]
  }

  // page content
  let {
  imageRelPath,
  body,
  created,
  drupal_internal__nid,
  field_summary_plain,
  moderation_state,
  field_author_data,
  field_product_or_service,
  field_relate_understand_finance,
  field_prospects_issue,
  issue_download_data,
  prospects_download,
  relatedContent,
  field_eq_52_week,
  field_eq_hist,
  field_eq_market_cap,
  field_eq_net_yeild,
  field_eq_price,
  field_show_important_notice,
  eq_data,
  displayTitle,
  articleDownload
  } = ''

  let displayEquities = false

  if(data.content) {

    //console.log(data.content)

    if (data.content.moderation_state) moderation_state = data.content.moderation_state
    if(moderation_state === "published") {
      if (data.content.created) created = safeDate(data.content.created)

      if (data.content.field_summary_plain) {
        field_summary_plain = data.content.field_summary_plain

        // deal with super long summaries
        // trim to the first .
        if(field_summary_plain.length > 300) {
          field_summary_plain = field_summary_plain.split(".")[0]
        }
      }

      // article download
      if(data.content.relationships.field_document_related_to_this_a) {
        if(data.content.relationships.field_document_related_to_this_a.relationships) {
          if(data.content.relationships.field_document_related_to_this_a.relationships.field_upload_document) {
            if(data.content.relationships.field_document_related_to_this_a.relationships.field_upload_document.name) {
              let filename = data.content.relationships.field_document_related_to_this_a.relationships.field_upload_document.name

              if(data.content.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships) {
                if(data.content.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships.field_document) {
                  if(data.content.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships.field_document.localFile) {
                    if(data.content.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships.field_document.localFile.publicURL) {
                      let linkUrl = data.content.relationships.field_document_related_to_this_a.relationships.field_upload_document.relationships.field_document.localFile.publicURL

                      articleDownload = (
                        <Container className="article-download text-center" name="articleDownload" fluid>
                          <Row>
                            <Col xs={12}>
                              <p className="h3">{filename}</p>
                              <a onClick={e => {
                                trackCustomEvent({
                                  category: "Document download",
                                  action: "Click",
                                  label: filename
                                })
                              }} href={linkUrl} title={filename} target="_blank" rel="noreferrer" className="btn btn-secondary">Download<IconDownload width="24" /></a>
                            </Col>
                          </Row>
                        </Container>
                      )
                    }
                  }
                }
              }
            }
          }
        }
      }


      if (data.content.drupal_internal__nid) drupal_internal__nid = data.content.drupal_internal__nid

      if(data.content.body){
        if (data.content.body.value) body = data.content.body.value
      }

      if(data.content.relationships) {
        if(data.content.relationships.field_image) {
          imageRelPath = imageFile(data.content.relationships.field_image, data.title)
        }

        if(data.content.relationships.field_author[0]) {
          field_author_data = data.content.relationships.field_author
        }

        if(data.content.relationships.field_product_or_service) {
          field_product_or_service = data.content.relationships.field_product_or_service
        }

        if(data.content.relationships.field_relate_understand_finance) {
          field_relate_understand_finance = data.content.relationships.field_relate_understand_finance

          if(field_relate_understand_finance.length < 1){
            let default_data = {
              drupal_internal__nid: 0,
              field_summary_plain: "Helping clients understand what we do is key to building relationships. To explain some of the industry jargon that creeps into our world, we’ve pulled together a section of our site to help.",
              path: {alias: "/our-insights/understanding-finance"},
              title: "Understanding Finance"
            }
            field_relate_understand_finance.push(default_data)
          }
          field_product_or_service = field_product_or_service.concat(field_relate_understand_finance)
        }

        if(data.content.relationships.field_article_category) {
          let pos = data.content.relationships.field_article_category.map(function(e) { return e.name; }).indexOf('Equity prospects')
          let pos2 = data.content.relationships.field_article_category.map(function(e) { return e.name; }).indexOf('Stock in focus')
          if(pos >= 0 || pos2 >= 0) {
            displayEquities = true
          }

          let pos3 = data.content.relationships.field_article_category.map(function(e) { return e.name; }).indexOf('Understanding Finance')
          if(pos3 >= 0) {
            // Understanding Finance section overrides:

            created = "" // clear the date for understanding finance content

            imageRelPath = (
              <UnderstandingFinanceImage />
            )

          }
        }



        if(data.content.relationships.field_prospects_issue) {

          let field_hex_color = ""
          let issue = data.content.relationships.field_prospects_issue
          if(issue.relationships) {
            if(issue.relationships.field_issue_theme_colour) {
              field_hex_color = issue.relationships.field_issue_theme_colour.field_hex_color
              //colour_class = safeName(issue.relationships.field_issue_theme_colour.name)
            }
          }

          // get download issue data
          if(issue.relationships.field_issue_theme_colour) {
            let field_hex_color, colour_name = ""
            field_hex_color = issue.relationships.field_issue_theme_colour.field_hex_color
            colour_name = issue.relationships.field_issue_theme_colour.name
            issue_download_data = {}
            issue_download_data.field_hex_color = field_hex_color
            issue_download_data.colour_name = colour_name

            if(issue.relationships.field_download_version_of_the_is) {
              // file data
              issue_download_data.file_data = issue.relationships.field_download_version_of_the_is
            }

            prospects_download = (
              <ProspectsDownload data={issue_download_data} />
            )
          }

          field_prospects_issue = (
            <>
              <div className="banner__prospects__bg" />
              <FramerMotionAnimation delay={2.0} opacityStart={0} opacityEnd={1} transformXStart={0} transformXEnd={0} transformYStart={-50} transformYEnd={0}>
                <div className="banner__prospects text-center" style={{ background: field_hex_color }}>
                  <Container fluid>
                    <Row>
                      <Col xs={12} lg={{span:11, offset:1}}>
                        <p className="h2">Prospects
                          <span>{data.content.relationships.field_prospects_issue.field_display_name_}</span>
                        </p>
                        <Link to={data.content.relationships.field_prospects_issue.path.alias} className="back-link">
                        <ChevronLeft width="12" />Back to Issue
                        </Link>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </FramerMotionAnimation>
            </>
          )
        }

        // article related content
        if(data.content.relationships.field_prospects_issue) {
          relatedContent = (
            <ArticleTeasers data={data.prospectsTeasers} excludeNode={drupal_internal__nid} title="Also in this issue" limit={3} colPattern={colPattern} noMoreLink/>
          )
        }
        else{
          relatedContent = (
            <ArticleTeasers data={data.teasers} excludeNode={drupal_internal__nid} title="Related articles" limit={3} colPattern={colPattern} noMoreLink/>
          )
        }

        // important notice, must be linked to a prospects issue
        if(data.content.field_show_important_notice) {
          let field_important_notice_date = "the date of this issue" // fallback message if date not set in prospects taxonomy
          if(data.content.relationships) {
            if(data.content.relationships.field_prospects_issue) {
              if(data.content.relationships.field_prospects_issue.field_important_notice_date) {
                field_important_notice_date = data.content.relationships.field_prospects_issue.field_important_notice_date

              }
            }
          }

          field_show_important_notice = (
            <Row className="text-center">
              <Col>
                <ModalImportantNotice noticeDate={field_important_notice_date} />
              </Col>
            </Row>
          )
        }


        // equity data :: start
        let eqContent = false
        if(data.content.field_eq_52_week) {
          eqContent = true
          field_eq_52_week = (
            <Col xs={6} lg={3} xl={true} className="field_eq_52_week">
              <div className="tag-icon"><IconHighLow /></div>
              <div className="tag">52 Week High-Low</div>
              <div className="value">{data.content.field_eq_52_week}</div>
            </Col>
          )
        }
        if(data.content.field_eq_hist) {
          eqContent = true
          field_eq_hist = (
            <Col xs={6} lg={3} xl={true}  className="field_eq_hist">
              <div className="tag-icon"><IconHist /></div>
              <div className="tag">Hist / Pros Per</div>
              <div className="value">{data.content.field_eq_hist}</div>
            </Col>
          )
        }
        if(data.content.field_eq_market_cap) {
          eqContent = true
          field_eq_market_cap = (
            <Col xs={6} lg={3} xl={true}  className="field_eq_market_cap">
              <div className="tag-icon"><IconEquity /></div>
              <div className="tag">Equity Market Cap</div>
              <div className="value">{data.content.field_eq_market_cap}</div>
            </Col>
          )
        }
        if(data.content.field_eq_net_yeild) {
          eqContent = true
          field_eq_net_yeild = (
            <Col xs={6} lg={3} xl={true}  className="field_eq_net_yeild">
              <div className="tag-icon"><IconYield /></div>
              <div className="tag">Net Yield</div>
              <div className="value">{data.content.field_eq_net_yeild}</div>
            </Col>
          )
        }
        if(data.content.field_eq_price) {
          eqContent = true
          field_eq_price = (
            <Col xs={6} lg={3} xl={true}  className="field_eq_price">
              <div className="tag-icon"><IconPrice /></div>
              <div className="tag">Price</div>
              <div className="value">{data.content.field_eq_price}</div>
            </Col>
          )
        }

        if(eqContent === true && displayEquities === true) {
          eq_data = (
            <FramerMotionAnimation delay={1.4} opacityStart={0} opacityEnd={1} transformXStart={0} transformXEnd={0} transformYStart={50}
 transformYEnd={0}>
            <Row className="text-center">
              <Col xs={12}>
                <Container className="eq-data-table text-left" fluid>
                  <Row className="justify-content-md-center">
                    {field_eq_price}
                    {field_eq_52_week}
                    {field_eq_net_yeild}
                    {field_eq_hist}
                    {field_eq_market_cap}
                  </Row>
                </Container>
              </Col>
            </Row>
            </FramerMotionAnimation>
          )
        }
        // equity data :: end

        // video superceeds image here
        if(data.content.field_video_url_embed_code) {
          imageRelPath = (
            <div className="articles__video" dangerouslySetInnerHTML={{__html: data.content.field_video_url_embed_code}}></div>
          )
        }

      }


      // imported articles are all summary and no body (but have whitespace)
      if(body === undefined || body.length < 1) {
        //console.log(body.length)
        body = nl2br(field_summary_plain)
        field_summary_plain = ""
      }

      // cater for long titles, make the font smaller
      if(title.length > 35) {
        displayTitle = (
          <h1 className="h2 articles__title">{ title }</h1>
        )
      }
      else {
        displayTitle = (
          <h1 className="articles__title">{ title }</h1>
        )
      }

    }
  }


  return (
    <Layout pageInfo={{ pageName: "index" }}>
      {/* SEO - start */}
      <SEO drupal_id={id} title={title} key={id} />
      <Helmet>
        {renderHead(title, data.content.field_meta_tags, data.content, id)}
      </Helmet>
      {/* SEO - end */}
      <section className="articles">
        {field_prospects_issue}
        <Container fluid>
          <Row>
            <Col xs={12} lg={5} xl={{span:5, offset:1}}>
              <p className="articles__date-created hr hr--top">
                { created }
              </p>
              <FramerMotionAnimation delay={0.3} opacityStart={0} opacityEnd={1} transformXStart={-50} transformXEnd={0} transformYStart={0} transformYEnd={0}>
                { displayTitle }
                <p className="articles__summary">{field_summary_plain}</p>
                <PeopleTeasers data={field_author_data} title="" colPattern={{xs:[12],md:[12],lg:[12]}} displayStyle="small" />
              </FramerMotionAnimation>
            </Col>
            <Col xs={12} lg={7} xl={6}>
              <FramerMotionAnimation delay={0.7} opacityStart={0} opacityEnd={1} transformXStart={50} transformXEnd={0} transformYStart={0} transformYEnd={0}>
                <div className="articles__image">
                  {imageRelPath}
                </div>
              </FramerMotionAnimation>
            </Col>
          </Row>
          {eq_data}
        </Container>
        <hr />
        <section className="articles__main-content">
          <Container fluid>
          <Row>
            <Col id="contentCol" xs={12} lg={{span:6, offset:1}} xl={{span:6, offset:1}}>
              <FramerMotionAnimation delay={1.4} opacityStart={0} opacityEnd={1} transformXStart={0} transformXEnd={0} transformYStart={50}
 transformYEnd={0}>
                <div className="rich__text" dangerouslySetInnerHTML={{__html: richTextFilter(body)}}></div>
                {articleDownload}
              </FramerMotionAnimation>
            </Col>
            <Col id="productCol" className="product-teaser" xs={12} lg={{span:3, offset:1}} xl={{span:3, offset:1}}>
              <ProductTeasers data={field_product_or_service} title="" btnVariant="outline-light" jumboClassTitle="hr hr--top" />{/**/}
            </Col>
          </Row>
          {field_show_important_notice}
          </Container>
        </section>
        <hr />
        <Container fluid>
          <Row>
            <Col xs={12} lg={{span:10, offset:1}}>
              <section className="paragraph__articles">
                {relatedContent}
              </section>
            </Col>
          </Row>
        </Container>
      </section>
      <Subscribe/>
      {prospects_download}
    </Layout>
  )
}
//,
export const query = graphql`query ($slug: String!,
$filter: String = "Insights", $prospectsId: Int!, $dateCreated: Date!) {
  content: nodeArticle(path: {alias: {eq: $slug}}) {
    field_meta_tags {
      title
      description
      keywords
      image_src
      robots
      canonical_url
      og_title
      og_determiner
      og_description
      og_image
      og_site_name
      og_url
      twitter_cards_description
      twitter_cards_site
      twitter_cards_site_id
      twitter_cards_title
      twitter_cards_type
      twitter_cards_creator
      twitter_cards_image
      twitter_cards_page_url
      schema_article_author
      schema_article_date_published
      schema_article_description
      schema_article_headline
      schema_article_name
      schema_article_review
      schema_article_type
      schema_person_contact_point
      schema_person_description
      schema_person_email
      schema_person_job_title
      schema_person_name
      schema_person_same_as
      schema_person_telephone
      schema_person_type
      schema_person_url
      schema_web_site_name
      schema_web_site_publisher
      schema_web_site_type
      schema_web_site_url
    }
    path {
      alias
      langcode
    }
    drupal_internal__nid
    title
    created
    field_summary_plain
    moderation_state
    body {
      summary
      value
    }
    field_eq_52_week
    field_eq_hist
    field_eq_market_cap
    field_eq_net_yeild
    field_eq_price
    field_feed_guid
    field_show_important_notice
    field_video_url_embed_code
    relationships {
      field_document_related_to_this_a {
        relationships {
          field_upload_document {
            name
            relationships {
              field_document {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
      field_prospects_issue {
        field_display_name_
        field_important_notice_date
        path {
          alias
        }
        relationships {
          field_download_version_of_the_is {
            relationships {
              field_image {
                relationships {
                  media__image {
                    relationships {
                      image {
                        localFile {
                          childImageSharp {
                            gatsbyImageData(
                              width: 600
                              quality: 90
                              layout: CONSTRAINED
                            )
                          }
                        }
                      }
                    }
                  }
                }
              }
              field_upload_document {
                name
                relationships {
                  field_document {
                    localFile {
                      publicURL
                    }
                  }
                }
              }
            }
          }
          field_issue_theme_colour {
            field_hex_color
            name
          }
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 900
                  height: 300
                  quality: 90
                  layout: CONSTRAINED
                )
              }
            }
          }
        }
      }
      field_image {
        localFile {
          childImageSharp {
            gatsbyImageData(
              width: 900
              height: 600
              quality: 90
              layout: CONSTRAINED
            )
          }
        }
      }
      field_article_category {
        name
      }
      field_article_type {
        name
      }
      field_author {
        drupal_internal__nid
        title
        field_email
        path {
          alias
        }
        field_job_title
        field_phone_number
        relationships {
          field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 300
                  height: 300
                  quality: 90
                  layout: CONSTRAINED
                )
              }
            }
          }
          field_department {
            name
            drupal_internal__tid
          }
          field_office {
            title
            drupal_internal__nid
          }
        }
      }
      field_generation_ref {
        name
        drupal_internal__tid
      }
      field_product_or_service {
        drupal_internal__nid
        title
        field_phone_number
        field_summary_plain
        path {
          alias
        }
        relationships {
          field_background_colour {
            field_hex_color
            name
          }
        }
      }
      field_relate_understand_finance {
        drupal_internal__nid
        title
        field_summary_plain
        path {
          alias
        }
      }
      taxonomy_term__generation {
        name
        drupal_internal__tid
      }
    }
  }
  teasers: allNodeArticle(
    filter: {moderation_state: {eq: "published"}, relationships: {field_article_category: {elemMatch:
{name: {eq: $filter}}}}}
    limit: 4
    sort: {created: DESC}
  ) {
    nodes {
      title
      field_summary_plain
      drupal_internal__nid
      path {
        alias
      }
      created
      relationships {
        field_article_category {
          name
        }
        field_image {
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 400
                height: 300
                quality: 90
                transformOptions: {cropFocus: CENTER}
                layout: CONSTRAINED
              )
            }
          }
        }
      }
    }
  }
  prospectsTeasers: allNodeArticle(
    filter: {moderation_state: {eq: "published"}, relationships: {field_prospects_issue:
{drupal_internal__tid: {eq: $prospectsId}}}, created: {lte: $dateCreated}}
    limit: 4
    sort: {created: DESC}
  ) {
    nodes {
      title
      field_summary_plain
      drupal_internal__nid
      path {
        alias
      }
      created
      relationships {
        field_article_category {
          name
        }
        field_image {
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 400
                height: 300
                quality: 90
                transformOptions: {cropFocus: CENTER}
                layout: CONSTRAINED
              )
            }
          }
        }
      }
    }
  }
}`

export default ArticlePage

